import React, { useEffect } from "react";
import { useForm } from "react-hook-form"; // Importing useForm
import TextField from "@mui/material/TextField";
import { Typography, Box, Container } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";

import { doc, setDoc } from "firebase/firestore";

import { useNavigate, useParams } from "react-router-dom";
import { fireDB } from "../config";

export default function AddUser() {
  const params = useParams();
  const navigate = useNavigate();

  const { register, handleSubmit, setValue } = useForm({
    defaultValues: {
      email: "",
      password: "",
      location: "",
      type: "",
      status: 1,
    },
  }); // Initializing useForm

  const onSubmit = async (data) => {
    try {
      let body = {
        email: data.email,
        password: data.password,
        location: data.location,
        type: data.type,
        status: data.status === "1" ? true : false,
      };
      if (params?.item) {
        await setDoc(doc(fireDB, "users", params.item), body);
        alert("the user is set successfully");
        navigate("/dashboard/users");
      } else {
        // Make your POST request here
      }
    } catch (err) {
      console.log(err);
      alert(err.message);
    }
  };

  useEffect(() => {
    if (params?.item) {
      let item = JSON.parse(params.item);
      setValue("email", item.email);
      setValue("type", item.type);
      setValue("password", item.password);
      setValue("location", item.location);
      setValue("status", item.status ? "1" : "0");
    }
  }, [params, setValue]);

  return (
    <Container
      sx={{
        justifyContent: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
      maxWidth="sm"
    >
      <Typography variant="h5" sx={{ fontWeight: "bold" }} gutterBottom>
        Create User
      </Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormControl fullWidth sx={{ my: 1 }}>
          <InputLabel>Select Location</InputLabel>
          <Select {...register("location")} label="Select Location">
            <MenuItem value={"1 Eva Rd #108, Etobicoke, ON M9C 4Z5,    Canada"}>
              1 Eva Rd #108, Etobicoke, ON M9C 4Z5, Canada
            </MenuItem>
            <MenuItem
              value={"3390 S Service Rd, Burlington, ON L7N 3J5, Canada"}
            >
              3390 S Service Rd, Burlington, ON L7N 3J5, Canada
            </MenuItem>
            <MenuItem
              value={"1225 Kennedy Rd, Scarborough, ON M1P 4Y1, Canada"}
            >
              1225 Kennedy Rd, Scarborough, ON M1P 4Y1, Canada
            </MenuItem>
          </Select>
        </FormControl>
        <TextField
          {...register("email")}
          fullWidth
          sx={{ my: 1 }}
          label="Enter email"
          color={"primary"}
        />
        <FormControl fullWidth sx={{ my: 1 }}>
          <InputLabel>Select Type</InputLabel>
          <Select {...register("type")} label="Select Type">
            <MenuItem value={"owner"}>Admin</MenuItem>
            <MenuItem value={"manager"}>Manager</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth sx={{ my: 1 }}>
          <InputLabel>Status</InputLabel>
          <Select {...register("status")} label="Status">
            <MenuItem value={"0"}>In-Active</MenuItem>
            <MenuItem value={"1"}>Active</MenuItem>
          </Select>
        </FormControl>
        <TextField
          {...register("password")}
          fullWidth
          label="Password"
          sx={{ my: 1 }}
          color="primary"
        />
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            type="submit"
            variant="contained"
            sx={{
              my: 2,
            }}
          >
            Add User
          </Button>
        </Box>
      </form>
    </Container>
  );
}
